import { render, staticRenderFns } from "./RepeatRegister.vue?vue&type=template&id=488bc77a&"
import script from "./RepeatRegister.vue?vue&type=script&lang=js&"
export * from "./RepeatRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports